import ResponsiveModal from '@/components/ui/modal/ResponsiveModal';
import EmptyPlaceholder from '@/components/ui/EmptyPlaceholder';
import { useMarkNotificationRead } from '../api/mutations';
import { Pagination } from 'antd';
import dayjs from 'dayjs';
import { type ApiListResponse, type Notification } from '@dc-trans/data-layer';
import { CheckCircle2, Circle } from 'lucide-react';
import { Spin } from 'pink-lava-ui';

interface NotificationModalProps {
  isOpen: boolean;
  onClose: () => void;
  notificationResponse: ApiListResponse<Notification>['data'];
  notifPage: number;
  setNotifPage: (_page: number) => void;
  isLoading: boolean;
}

const NotificationModal = ({
  isOpen,
  onClose,
  notificationResponse,
  setNotifPage,
  isLoading,
  notifPage,
}: NotificationModalProps) => {
  const { mutate: markAsRead } = useMarkNotificationRead();

  const notifications = notificationResponse?.items || [];
  const meta = notificationResponse?.meta;

  return (
    <ResponsiveModal
      title="Notifikasi"
      open={isOpen}
      centered
      width={580}
      onCancel={onClose}
      footer={<></>}
      fullscreenMaxBreakpoint="md"
    >
      <div className="flex flex-col overflow-auto min-h-[300px] py-2">
        {isLoading ? (
          <div className="flex justify-center items-center h-full p-8">
            <Spin size="large" spinning />
          </div>
        ) : notifications.length === 0 ? (
          <EmptyPlaceholder title="Notifikasi" />
        ) : (
          <>
            {notifications.map((item: Notification) => (
              <div
                key={item.ulid}
                className={`px-4 py-2 border-y ${!item.read_at ? 'bg-pink-50 border-pink-100' : 'bg-white border-gray-200'}`}
                onClick={() => markAsRead([item.ulid])}
              >
                <div className=" flex flex-row items-start gap-3">
                  {item.read_at ? (
                    <CheckCircle2 className="w-5 h-5 text-pink-500" />
                  ) : (
                    <Circle className="w-5 h-5 text-gray-500 cursor-pointer" onClick={() => markAsRead([item.ulid])} />
                  )}
                  <div className="flex-1">
                    <div className="text-sm text-gray-800 font-medium mb-1">{item.body}</div>
                    <div className="text-xs text-gray-500">{dayjs(item.created_at).format('YYYY-MM-DD HH:mm')}</div>
                  </div>
                  {!item.read_at ? <div className="w-2 h-2 rounded-full bg-pink-600 mt-1 flex-shrink-0" /> : null}
                </div>
              </div>
            ))}
            <div className="flex justify-center mt-4">
              <Pagination
                total={meta?.total}
                onChange={p => {
                  setNotifPage(p);
                }}
                pageSize={10}
                current={notifPage}
                showSizeChanger={false}
                align="center"
              />
            </div>
          </>
        )}
      </div>
    </ResponsiveModal>
  );
};

export default NotificationModal;
